import { render, staticRenderFns } from "./atc-menu.vue?vue&type=template&id=05b6bdb2&scoped=true&"
import script from "./atc-menu.vue?vue&type=script&lang=js&"
export * from "./atc-menu.vue?vue&type=script&lang=js&"
import style0 from "./atc-menu.vue?vue&type=style&index=0&id=05b6bdb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b6bdb2",
  null
  
)

export default component.exports